import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "option-info-message" }
const _hoisted_2 = { class: "option-info-message" }

import { MembershipTypeModel } from '@src/view_models/MembershipTypeModel';
import RadioField from '@src/components/shared/form_fields/RadioField.vue';
import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import { computed } from 'vue';

interface Props {
	modelValue: number;
	disabledMembershipTypes: number[];
	isMaxWidthField?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipTypeField',
  props: {
    modelValue: {},
    disabledMembershipTypes: {},
    isMaxWidthField: { type: Boolean }
  },
  emits: [ 'update:modelValue' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const fieldModel = useFieldModel<number>( () => props.modelValue, props.modelValue );

const onUpdateModel = ( newValue: number ): void => {
	emit( 'update:modelValue', newValue );
};

const activeTypeSelectedAndDisabled = computed( (): boolean => {
	const activeOptionIsDisabled = props.disabledMembershipTypes.indexOf( MembershipTypeModel.ACTIVE ) > -1;
	return fieldModel.value === MembershipTypeModel.ACTIVE && activeOptionIsDisabled;
} );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RadioField, {
    name: "membershipType",
    label: _ctx.$t('membership_form_membershiptype_legend'),
    options: [
			{
				value: _unref(MembershipTypeModel).SUSTAINING,
				label: _ctx.$t( 'membership_form_membershiptype_option_sustaining' ),
				id: 'membershipType-0',
			},
			{
				value: _unref(MembershipTypeModel).ACTIVE,
				label: _ctx.$t( 'membership_form_membershiptype_option_active' ),
				id: 'membershipType-1',
			},
		],
    modelValue: _unref(fieldModel),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
      onUpdateModel
    ],
    alignment: "column",
    disabled: __props.disabledMembershipTypes,
    "show-error": activeTypeSelectedAndDisabled.value,
    "error-message": _ctx.$t('membership_form_membershiptype_error'),
    "is-max-width-field": __props.isMaxWidthField
  }, {
    "message-0": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t( 'membership_form_membershiptype_option_sustaining_legend' )), 1)
    ]),
    "message-1": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t( 'membership_form_membershiptype_option_active_legend' )), 1)
    ]),
    _: 1
  }, 8, ["label", "options", "modelValue", "disabled", "show-error", "error-message", "is-max-width-field"]))
}
}

})